import React from 'react';
import {
  ArrayInput,
  ReferenceInput,
  required,
  FormDataConsumer,
  AutocompleteInput,
  SimpleFormIterator,
  TextInput,
  useTranslate,
  maxLength,
  minLength,
  regex,
} from 'react-admin';
import { Grid } from '@material-ui/core';
import { DocumentSegment, DocumentType } from '../Utils/enums';

const validateOtherDocuments = (values: any) => {
  const errors: any = [];
  const docRegex = /^[a-zA-Z0-9]*$/;
  if (Array.isArray(values)) {
    values.forEach((doc, index) => {
      const docErrors: any = {};
      if (!doc?.documentType)
        docErrors.documentType = 'El tipo de documento es obligatorio';
      if (!doc?.documentNumber)
        docErrors.documentNumber = 'El número de documento es obligatorio';
      else if (!docRegex.test(doc.documentNumber))
        docErrors.documentNumber = 'Solo letras y números (sin símbolos)';
      if (Object.keys(docErrors).length > 0) errors[index] = docErrors;
    });
  }
  return errors;
};

  function alphanumericNoSymbols() {
    return (value: string) => {

      if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
        return 'Solo letras y números (sin símbolos)';
      }
      return undefined;
    };
  }

const OtherDocuments = ({ record, resource, ...rest }) => {
  const translate = useTranslate();

  return (
    <ArrayInput
      source='otherDocuments'
      label=''
      validate={validateOtherDocuments}
      {...rest}
    >
      <SimpleFormIterator>
        <FormDataConsumer>
          {({ scopedFormData, getSource,  }) => {
            return (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <ReferenceInput
                    source={getSource(
                      record?.id ? 'documentType.id' : 'documentType'
                    )}
                    reference='document-types'
                    resource='other-documents'
                    variant='outlined'
                    validate={[required()]}
                    label={translate(
                      'resources.other-documents.fields.documentType'
                    )}
                    fullWidth
                    filter={{
                      segment: 'info',
                      documentSegment:
                        resource === 'people'
                          ? DocumentSegment.Personal.id
                          : DocumentSegment.Business.id,
                    }}
                  >
                    <AutocompleteInput />
                  </ReferenceInput>
                </Grid>
                <Grid item xs={6}>
                  <TextInput
                    source={getSource('documentNumber')}
                    validate={
                      scopedFormData?.documentType === DocumentType.Passport
                        ? [
                            required(),
                            minLength(9),
                            maxLength(9, 'Debe tener 9 caracteres'),
                            regex(
                              /^[A-Z][0-9]{8}$/,
                              'Formato incorrecto: 1 letra y 8 números (ej. G12345678).'
                            ),
                          ]
                        : scopedFormData?.documentType === DocumentType.FRCPersonal
                        ? [required(), minLength(13), maxLength(13, 'Debe tener 13 caracteres'), alphanumericNoSymbols()]
                        : scopedFormData?.documentType === DocumentType.CURP
                        ? [required(), minLength(18), maxLength(18, 'Debe tener 18 caracteres'), alphanumericNoSymbols()]
                        : [required(), maxLength(40), alphanumericNoSymbols()]
                    }
                    resource='other-documents'
                    label={translate(
                      'resources.other-documents.fields.documentNumber'
                    )}
                    variant='outlined'
                    fullWidth
                  />
                </Grid>
              </Grid>
            );
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default OtherDocuments;